import React from "react";
import { ShieldCheck } from "lucide-react";

// Circular trust-score ring (0-100) — reputation signal for creators.
export function TrustRing({ score = 0, size = 56 }) {
  const s = Math.min(100, Math.max(0, Number(score) || 0));
  const stroke = 6;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const off = c * (1 - s / 100);
  const color = s >= 75 ? "#10b981" : s >= 50 ? "#f59e0b" : "#94a3b8";
  return (
    <div className="relative inline-grid place-items-center shrink-0" style={{ width: size, height: size }} data-testid="trust-ring">
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="hsl(var(--border))" strokeWidth={stroke} />
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth={stroke} strokeLinecap="round"
          strokeDasharray={c} strokeDashoffset={off} style={{ transition: "stroke-dashoffset 0.8s ease" }} />
      </svg>
      <div className="absolute font-extrabold tabular-nums" style={{ color, fontSize: size * 0.32 }}>{s}</div>
    </div>
  );
}

// Compact "Verified Original Creator" chip.
export function VerifiedCreatorBadge({ className = "", showLabel = true }) {
  return (
    <span data-testid="verified-creator-badge" title="Verified Original Creator — publishes IP-clean, AI-provenance-certified games"
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-bold bg-emerald-500/12 text-emerald-500 ${className}`}>
      <ShieldCheck className="w-3.5 h-3.5" />{showLabel && "Verified Creator"}
    </span>
  );
}

export default TrustRing;
